import { EntryWithID } from '@/components/cms/types/entry';
import { getCountForm } from '@/components/countdown/utils';

import { BlockHeaderContent } from '@/features/utils/BlockHeaderContentDC';
import { BlockWrapper } from '@/features/utils/BlockWrapperDC';

import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';
import RelatedArticles from '../relatedArticles';
import { transformBlogArticlesIntoRelatedArticlesProps } from './service';
import { getIntlText } from '@/lib/i18n/i18n.server';
import { useTranslation } from '@/lib/i18n/i18n.client';

export function EmptyFeed({
  query,
  articles,
}: {
  query: string;
  articles: EntryWithID[];
}) {
  const { texts } = useTranslation();

  return (
    <div className='w-full'>
      <BlockWrapper
        data-tracker-section={SECTION_NAMES.ARTICLES_FEED}
        classNames={{ root: 'pt-8 md:pt-12 lg:pt-12' }}
        data-tracker-component='articles-feed'
      >
        <FeedResultsHeader count={0} query={query} />
      </BlockWrapper>
      <BlockWrapper
        data-tracker-section={SECTION_NAMES.ARTICLES_FEED}
        classNames={{ root: 'bg-gray-25' }}
        data-tracker-component='articles-feed'
      >
        <BlockHeaderContent title={texts.articles_feed.newest_articles}>
          <RelatedArticles
            items={transformBlogArticlesIntoRelatedArticlesProps(articles)}
          />
        </BlockHeaderContent>
      </BlockWrapper>
    </div>
  );
}

export function FeedResultsHeader({
  count,
  query,
}: {
  count: number;
  query: string;
}) {
  const { texts } = useTranslation();

  return (
    <div className='space-y-6'>
      <p className='text-body-l text-gray-700'>
        {getIntlText(texts.articles_feed.search_in_blog, {
          count: String(count),
          posts: getCountForm(
            count,
            texts.articles_feed.post,
            texts.articles_feed.posts
          ),
        })}
      </p>
      <p className='text-h2 text-lg'>{query}</p>
      {count === 0 && (
        <p className='text-body-l text-gray-700'>
          {texts.articles_feed.please_try_again}
        </p>
      )}
    </div>
  );
}
